import { FC } from 'react'
import cn from 'classnames'
import { IMessage } from '@/context/types'
import { getAgentInitials } from '../utils'

interface AgentAssignedProps {
  message: IMessage
}

const AgentAssigned: FC<AgentAssignedProps> = ({ message }) => {
  return (
    <div className="pmui-flex pmui-justify-center pmui-my-4">
      <div className="pmui-flex pmui-flex-col pmui-items-center pmui-gap-2 ">
        <div
          className={cn(
            'pmui-inline-flex pmui-justify-center pmui-items-center \
                       pmui-overflow-hidden \
                       md:pmui-w-12 md:pmui-h-12 md:pmui-mr-3 \
                       pmui-w-10 pmui-h-10 pmui-mr-2 \
                       pmui-rounded-full pmui-bg-gray-600 avatar',
          )}
        >
          <span className="pmui-text-lg sm:pmui-text-sm md:pmui-text-base pmui-text-white">
            {getAgentInitials(
              message.metadata?.agentFirstName,
              message.metadata?.agentLastName,
            )}
          </span>
        </div>
        <div className="pmui-text-sm pmui-text-pop-gray-300">
          {message.content.text}
        </div>
      </div>
    </div>
  )
}

export default AgentAssigned
